export default function SectionHeading({ overline, title, sub, align = "left", className = "" }) {
  const wrap = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${wrap} gap-5 ${className}`}>
      {overline && <div className="overline">{overline}</div>}
      <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#1A1A1A] max-w-3xl">
        {title}
      </h2>
      {sub && (
        <p className={`text-[15px] text-[#2E2E2E]/70 leading-relaxed max-w-2xl font-light ${align === "center" ? "mx-auto" : ""}`}>
          {sub}
        </p>
      )}
    </div>
  );
}
